import Image from '@/components/UI/Image';
import { intlNumber } from '@/utils';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export default function TabInfo({ timeList, webpUrl = '' }: any) {
    const { useState, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_max_static');
    const { EFPic } = createEFPic(webpUrl);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [tabPosition, setTabPosition] = useState({
        tabWidth: '1rem',
        offsetLeft: locale === 'sa' ? '273' : '',
    });
    type iconInfo = {
        icon: string;
        device: string;
        usageTime: {
            time: number;
            unit: string;
            port?: string;
        }[];
    };
    type useTimeList = {
        key: number;
        title: string;
        // img: string;
        content: iconInfo[];
    };
    const useTimeList: useTimeList[] = timeList || [
        {
            key: 0,
            title: 'Home Backup',
            // img: '/product/deltamax/useTime/delta-max01.png',
            content: [
                {
                    icon: '/product/deltamax/useTime/homeBc01.png',
                    device: 'Light',
                    usageTime: [{ time: 189, unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/homeBc02.png',
                    device: 'CPAP',
                    usageTime: [{ time: 34, unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/homeBc03.png',
                    device: 'Refrigerator',
                    usageTime: [{ time: 14, unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/homeBc04.png',
                    device: 'Microwave',
                    usageTime: [{ time: intlNumber(locale, 1.5), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/homeBc05.png',
                    device: 'Washer',
                    usageTime: [{ time: intlNumber(locale, 3.8), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/homeBc09.png',
                    device: 'Electric Frying Pan',
                    usageTime: [{ time: intlNumber(locale, 1.6), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/homeBc06.png',
                    device: '50" TV',
                    usageTime: [{ time: 15, unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/homeBc07.png',
                    device: 'Hair Dryer',
                    usageTime: [{ time: intlNumber(locale, 1.1), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/homeBc08.png',
                    device: 'Coffee Maker',
                    usageTime: [{ time: intlNumber(locale, 1.9), unit: t('Hrs') }],
                },
            ],
        },
        {
            key: 1,
            title: 'Off-Grid Life',
            // img: '/product/deltamax/useTime/delta-max02.png',
            content: [
                {
                    icon: '/product/deltamax/useTime/offGL01.png',
                    device: 'Phone',
                    usageTime: [{ time: 175, unit: t('Times') }],
                },
                {
                    icon: '/product/deltamax/useTime/offGL02.png',
                    device: 'Laptop',
                    usageTime: [{ time: 32, unit: t('Times') }],
                },
                {
                    icon: '/product/deltamax/useTime/offGL03.png',
                    device: 'Camera',
                    usageTime: [{ time: 118, unit: t('Times') }],
                },
                {
                    icon: '/product/deltamax/useTime/offGL04.png',
                    device: 'Drone',
                    usageTime: [{ time: 48, unit: t('Times') }],
                },
                {
                    icon: '/product/deltamax/useTime/offGL05.png',
                    device: 'Speaker',
                    usageTime: [{ time: 60, unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/offGL06.png',
                    device: 'Blender',
                    usageTime: [{ time: intlNumber(locale, 3.8), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/offGL07.png',
                    device: 'Car Fridge',
                    usageTime: [{ time: 33, unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/offGL08.png',
                    device: 'Projector',
                    usageTime: [{ time: 24, unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/offGL09.png',
                    device: 'PS5',
                    usageTime: [{ time: 9, unit: t('Hrs') }],
                },
            ],
        },
        {
            key: 2,
            title: 'Professional',
            // img: '/product/deltamax/useTime/delta-max03.png',
            content: [
                {
                    icon: '/product/deltamax/useTime/professional01.png',
                    device: 'Circular Saw',
                    usageTime: [{ time: intlNumber(locale, 1.3), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/professional02.png',
                    device: 'Air Conditioner',
                    usageTime: [{ time: 1, unit: 'Hr' }],
                },
                {
                    icon: '/product/deltamax/useTime/professional03.png',
                    device: 'Electric Hammer',
                    usageTime: [{ time: intlNumber(locale, 1.5), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/professional04.png',
                    device: 'Electric Drill',
                    usageTime: [{ time: intlNumber(locale, 1.8), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/professional05.png',
                    device: 'Cutting Machine',
                    usageTime: [{ time: intlNumber(locale, 1.7), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/professional06.png',
                    device: 'Electric Oven',
                    usageTime: [{ time: intlNumber(locale, 1.1), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/professional07.png',
                    device: 'Electric Grill',
                    usageTime: [{ time: intlNumber(locale, 1.7), unit: t('Hrs') }],
                },
                {
                    icon: '/product/deltamax/useTime/professional08.png',
                    device: 'Air Fryer',
                    usageTime: [{ time: intlNumber(locale, 1.2), unit: t('Hrs') }],
                },
            ],
        },
    ];

    const handleChangeTab = (key: number, event: any) => {
        const dom = event.target;
        const { clientWidth, offsetLeft } = dom;
        console.log('offsetLeft', offsetLeft);

        if (dom) {
            setTabPosition({ tabWidth: clientWidth, offsetLeft });
            setCurrentIndex(key);
        }
    };

    return (
        <div className={`${css.use_time} use_time`}>
            <div className="container">
                <div className="head font-family-bold">
                    <div className="l1">{t('switch_tab_title1')}</div>
                    <div className="l2"> {t(locale === 'jp' ? 'switch_tab_title2_h5' : 'switch_tab_title2')}</div>
                </div>
                <div className="tab">
                    <ul>
                        {useTimeList?.map((item) => (
                            <li
                                key={item.key}
                                className={`menuItem font-family-semibold ${currentIndex === item.key ? 'active' : ''}`}
                                onClick={(e) => handleChangeTab(item.key, e)}
                            >
                                {item.title}
                            </li>
                        ))}
                    </ul>
                    <div
                        className="line"
                        style={{
                            left: `${tabPosition.offsetLeft}px`,
                            width: `${tabPosition.tabWidth}px`,
                        }}
                    />
                </div>
                <ul className="content">
                    {useTimeList
                        .find((items: any) => items.key === currentIndex)
                        ?.content.map((item: any, i: number) => (
                            <li className="item" key={i}>
                                <div className="img-wrapper">
                                    {Array.isArray(item.icon) ? (
                                        <EFPic name={item.icon} alt={t(item.device)} />
                                    ) : typeof item.icon === 'string' && item.icon !== '' ? (
                                        <Image src={item.icon} layout="fill" alt={t(item.device)} />
                                    ) : (
                                        typeof item.icon !== 'string' && item.icon
                                    )}
                                </div>
                                <p className="device">{t(item.device)}</p>
                                <ul className="usageTime ">
                                    {item?.usageTime?.map((usageTimeItem: any, i: number) => (
                                        <li className="usageTimeItem font-family-bold" key={i}>
                                            <p>
                                                <strong className="time">{usageTimeItem.time}&nbsp;</strong>
                                                <span className="unit">{usageTimeItem.unit}</span>
                                            </p>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                </ul>
                {locale === 'cn' && <p className="memo">{t('useTime_memo')}</p>}
            </div>
        </div>
    );
}
